/* esm.sh - react-router@8.4.0/dist/production/lib/errors */
import{ErrorResponseImpl as R}from"react-router/dist/production/lib/router/utils";var o="REACT_ROUTER_ERROR",r="REDIRECT",s="ROUTE_ERROR_RESPONSE";function a(e){if(e.startsWith(`${o}:${r}:{`))try{let t=JSON.parse(e.slice(28));if(typeof t=="object"&&t&&typeof t.status=="number"&&typeof t.statusText=="string"&&typeof t.location=="string"&&typeof t.reloadDocument=="boolean"&&typeof t.replace=="boolean")return t}catch{}}function n(e){if(e.startsWith(`${o}:${s}:{`))try{let t=JSON.parse(e.slice(40));if(typeof t=="object"&&t&&typeof t.status=="number"&&typeof t.statusText=="string")return new R(t.status,t.statusText,t.data)}catch{}}export{a as decodeRedirectErrorDigest,n as decodeRouteErrorResponseDigest};
/*! Bundled license information:

react-router/dist/production/lib/errors.js:
  (**
   * react-router v8.4.0
   *
   * Copyright (c) Remix Software Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   *)
*/
//# sourceMappingURL=errors.mjs.map